<div class="p-t-m p-l-m">
	<button mat-button color="accent" (click)="goBack()" id="goBackButton">
		<div fxLayoutAlign="start center">
			<img
				height="16px"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/arrowBackAccent/public"
			/>&nbsp;
			<span i18n="@@custom_donationForm_fundraiserPage_button"
				>Fundraiser page</span
			>
		</div>
	</button>
</div>
<mat-tab-group
	mat-stretch-tabs="false"
	mat-align-tabs="start"
	color="accent"
	selectedIndex="0"
>
	<mat-tab label="{{ targetAmountTab }}">
		<app-target-amount
			[currentFundraiserData]="fundraiserData"
		></app-target-amount>
	</mat-tab>
	<mat-tab label="{{ donationAmountTab }}" id="donationAmount">
		<div fxLayout="row wrap">
			<mat-card class="mat-elevation-z0" fxFlex.gt-sm="49" fxFlex.lt-md="100">
				<mat-card-header
					fxLayout="row wrap"
					fxLayout.xs="column"
					fxLayoutAlign="space-between baseline"
				>
					<h2
						mat-card-title
						i18n="@@custom_donation_form_customizeDonationAmount_label"
					>
						Customise Donation Amount
					</h2>
					<mat-icon *ngIf="!fundraiserData?.slug" class="m-l-xs">
						<mat-spinner
							color="accent"
							diameter="16"
							i18n="@@custom_donation_page_spinner"
						>
						</mat-spinner>
					</mat-icon>
					<button
						mat-button
						color="accent"
						id="resetDefaultValues"
						(click)="setToDefault()"
						i18n="@@button_resetToDefaultValues"
					>
						Reset to default values
					</button>
				</mat-card-header>
				<mat-card-content>
					<form [formGroup]="customDonationForm">
						<br />
						<!-- One Time -->
						<div>
							<p>
								<mat-slide-toggle
									id="oneTimeCheckbox"
									type="checkbox"
									color="primary"
									formControlName="onetimeFlag"
								>
									<span i18n="@@custom_donation_form_allowOneTimeDonation_label"
										>Allow One Time Donation</span
									>
								</mat-slide-toggle>
							</p>
							<div
								formGroupName="onetimeCtrls"
								fxLayout="row wrap"
								fxLayoutAlign="start center"
							>
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
								>
									<span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="onetime1"
										matInput
										type="number"
										id="onetime1Input"
									/>
									<mat-error
										*ngIf="showError('onetimeCtrls', 'onetime1', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										*ngIf="showError('onetimeCtrls', 'onetime1', 'min')"
										id="onetime1MinErr"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
								>
									<span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="onetime2"
										matInput
										type="number"
										id="onetime2Input"
									/>
									<mat-error
										*ngIf="showError('onetimeCtrls', 'onetime2', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="onetime2MinErr"
										*ngIf="showError('onetimeCtrls', 'onetime2', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
								>
									<span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="onetime3"
										matInput
										type="number"
										id="onetime3Input"
									/>
									<mat-error
										*ngIf="showError('onetimeCtrls', 'onetime3', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="onetime3MinErr"
										*ngIf="showError('onetimeCtrls', 'onetime3', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
								>
									<span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="onetime4"
										matInput
										type="number"
										id="onetime4Input"
									/>
									<mat-error
										*ngIf="showError('onetimeCtrls', 'onetime4', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="onetime4MinErr"
										*ngIf="showError('onetimeCtrls', 'onetime4', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
								>
									<div matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</div>
									<input
										formControlName="onetime5"
										matInput
										type="number"
										id="onetime5Input"
									/>
									<mat-error
										*ngIf="showError('onetimeCtrls', 'onetime5', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="onetime5MinErr"
										*ngIf="showError('onetimeCtrls', 'onetime5', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
							</div>
							<p>
								OR &nbsp;&nbsp;&nbsp;<mat-slide-toggle
									id="onetimeOpenDonationStyle"
									color="primary"
									formControlName="onetimeOpenAmountFlag"
									i18n="@@custom_donation_form_setOpenDonationStyle_label"
									>Set Open donation style</mat-slide-toggle
								>
							</p>
						</div>

						<br />
						<!-- Monthly -->
						<div>
							<p>
								<mat-slide-toggle
									id="monthlyCheckbox"
									type="checkbox"
									formControlName="monthlyFlag"
									color="primary"
									><span
										i18n="@@custom_donation_form_allowMonthlyDonation_label"
										>Allow Monthly Donation</span
									>
								</mat-slide-toggle>
							</p>
							<div
								formGroupName="monthlyCtrls"
								fxLayout="row wrap"
								fxLayoutAlign="start center"
							>
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
								>
									<span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="monthly1"
										matInput
										type="number"
										id="monthly1Input"
									/>
									<mat-error
										*ngIf="showError('monthlyCtrls', 'monthly1', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="monthly1MinErr"
										*ngIf="showError('monthlyCtrls', 'monthly1', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
									><span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="monthly2"
										matInput
										type="number"
										id="monthly2Input"
									/>
									<mat-error
										*ngIf="showError('monthlyCtrls', 'monthly2', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="monthly2MinErr"
										*ngIf="showError('monthlyCtrls', 'monthly2', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
									><span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="monthly3"
										matInput
										type="number"
										id="monthly3Input"
									/>
									<mat-error
										*ngIf="showError('monthlyCtrls', 'monthly3', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="monthly3MinErr"
										*ngIf="showError('monthlyCtrls', 'monthly3', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
									><span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="monthly4"
										matInput
										type="number"
										id="monthly4Input"
									/>
									<mat-error
										*ngIf="showError('monthlyCtrls', 'monthly4', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="monthly4MinErr"
										*ngIf="showError('monthlyCtrls', 'monthly4', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
								>
									<div matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</div>
									<input
										formControlName="monthly5"
										matInput
										type="number"
										id="monthly5Input"
									/>
									<mat-error
										*ngIf="showError('monthlyCtrls', 'monthly5', 'max')"
									>
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="onetime5MinErr"
										*ngIf="showError('monthlyCtrls', 'monthly5', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
							</div>
							<p>
								OR &nbsp;&nbsp;&nbsp;<mat-slide-toggle
									id="monthlyOpenDonationStyle"
									formControlName="monthlyOpenAmountFlag"
									color="primary"
									i18n="@@custom_donation_form_setOpenDonationStyle_label"
									>Set Open donation style</mat-slide-toggle
								>
							</p>
						</div>

						<br />
						<!-- Yearly -->
						<div>
							<p>
								<mat-slide-toggle
									id="yearlyCheckbox"
									type="checkbox"
									formControlName="yearlyFlag"
									color="primary"
									><span
										i18n="@@custom_donation_form_allowYearlyDonation_label"
									>
										Allow Yearly Donation</span
									></mat-slide-toggle
								>
							</p>
							<div
								formGroupName="yearlyCtrls"
								fxLayout="row wrap"
								fxLayoutAlign="start center"
							>
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
									><span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="yearly1"
										matInput
										type="number"
										id="yearly1Input"
									/>
									<mat-error *ngIf="showError('yearlyCtrls', 'yearly1', 'max')">
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="yearly1MinErr"
										*ngIf="showError('yearlyCtrls', 'yearly1', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
									><span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="yearly2"
										matInput
										type="number"
										id="yearly2Input"
									/>
									<mat-error *ngIf="showError('yearlyCtrls', 'yearly2', 'max')">
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="yearly2MinErr"
										*ngIf="showError('yearlyCtrls', 'yearly2', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
									><span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="yearly3"
										matInput
										type="number"
										id="yearly3Input"
									/>
									<mat-error *ngIf="showError('yearlyCtrls', 'yearly3', 'max')">
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="yearly3MinErr"
										*ngIf="showError('yearlyCtrls', 'yearly3', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
									><span matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</span>
									<input
										formControlName="yearly4"
										matInput
										type="number"
										id="yearly4Input"
									/>
									<mat-error *ngIf="showError('yearlyCtrls', 'yearly4', 'max')">
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="yearly4MinErr"
										*ngIf="showError('yearlyCtrls', 'yearly4', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
								&nbsp;&nbsp;&nbsp;
								<mat-form-field
									appearance="outline"
									color="primary"
									fxFlex.xs="35"
									fxFlex.gt-xs="20"
								>
									<div matPrefix class="currency-input-field">
										{{ this.currency.symbol }}&nbsp;
									</div>
									<input
										formControlName="yearly5"
										matInput
										type="number"
										id="yearly5Input"
									/>
									<mat-error *ngIf="showError('yearlyCtrls', 'yearly5', 'max')">
										<span i18n="@@custom_donation_form_maximumAmountShort"
											>Max:</span
										>
										{{ this.currency.symbol }}{{ this.max_donation_amount }}
									</mat-error>
									<mat-error
										id="onetime5MinErr"
										*ngIf="showError('yearlyCtrls', 'yearly5', 'min')"
									>
										<span i18n="@@custom_donation_form_minimumAmountShort"
											>Min:</span
										>
										{{ this.currency.symbol }}{{ this.min_donation_amount }}
									</mat-error>
								</mat-form-field>
							</div>
							<p>
								OR &nbsp;&nbsp;&nbsp;<mat-slide-toggle
									id="yearlyOpenDonationStyle"
									formControlName="yearlyOpenAmountFlag"
									color="primary"
									i18n="@@custom_donation_form_setOpenDonationStyle_label"
									>Set Open donation style</mat-slide-toggle
								>
							</p>
						</div>

						<!-- <br />
						<div>
							<mat-slide-toggle
								formControlName="otherAmountFlag"
								id="otherAmountFlagButton"
								color="primary"
								><span i18n="@@custom_donationForm_allowOtherAmount_toggle"
									>Allow Other amount</span
								>
								<mat-hint class="mat-caption"
									><span i18n="custom_donation_form_allowDonorToDecide_hint"
										>(Allow donor to decide donation amount)</span
									></mat-hint
								>
							</mat-slide-toggle>
						</div> -->
						<br />
						<div>
							<mat-slide-toggle
								id="tipBoxFlagButton"
								formControlName="tipBoxFlag"
								color="primary"
								><span i18n="@@custom_donationForm_tipBoxEnabled_toggle">
									Tip box enabled</span
								></mat-slide-toggle
							>
							<div fxLayout="column" fxLayoutAlign="start start">
								<mat-hint
									class="mat-caption"
									i18n="@@custom_donationForm_disablingTheTio_hint"
									>Disabling the tip box will change the pricing for this
									fundraiser.</mat-hint
								>

								<a
									mat-button
									color="accent"
									i18n="@@button_pricingOptions"
									(click)="goToPricingOptions()"
								>
									Pricing options
								</a>
							</div>
						</div>
					</form>
					<div fxLayout="row" fxLayoutAlign="end center">
						<button
							mat-stroked-button
							color="accent"
							(click)="discardChanges()"
							[disabled]="isCustomDonationDisable"
							i18n="@@button_discard"
						>
							Discard
						</button>
						&nbsp;&nbsp;&nbsp;
						<button
							id="saveAndApply"
							mat-flat-button
							color="accent"
							[disabled]="isCustomDonationDisable || !customDonationForm.valid"
							(click)="saveAndApplyCustomDonation()"
						>
							<span i18n="@@button_saveAndApply">Save and Apply</span>

							<mat-icon *ngIf="isSaveCustomDonation" class="m-l-xs">
								<mat-spinner
									color="accent"
									diameter="16"
									i18n="@@custom_donation_form_spinner"
								>
								</mat-spinner>
							</mat-icon>
						</button>
					</div>
				</mat-card-content>
			</mat-card>
			<mat-divider vertical="true"></mat-divider>
			<mat-card class="mat-elevation-z0" fxFlex.gt-sm="50" fxFlex.lt-md="100">
				<mat-card-content>
					<div fxLayout="row" fxLayoutAlign="start center">
						<p fxLayout="row" class="mat-subtitle-2">
							<img
								class="m-t-xxs"
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/visibilityOn/public"
							/>&nbsp;
							<span
								ngClass="p-t-xxs"
								i18n="@@share_dialog_custom_donation_donationFormPreview_icon"
							>
								Donation Form Preview
							</span>
						</p>
					</div>
					<br />
					<!------- Preview ------------->
					<mat-card
						[ngStyle]="{
							width: _media.isActive('xs') == true ? '250px' : '470px'
						}"
					>
						<mat-card-content>
							<div fxLayout="column" class="donation-form-preview">
								<div fxLayout="column" fxLayoutAlign="start center" fxFill>
									<div
										fxLayout="row"
										fxLayoutAlign="start center"
										fxFlex="100%"
										*ngIf="fundraiserCardData?.length"
									>
										<div fxLayout="column">
											<div
												fxLayout="row"
												fxLayoutAlign="start center"
												class="m-b-m"
											>
												<div
													fxFlex="35"
													
												>
													<!-- Display image if available -->
													<img
														*ngIf="
															fundraiserData?.image?.src != null &&
															this.fundraiserData?.image?.src != '' &&
															!this.fundraiserData?.image?.video
														"
														[src]="fundraiserBackgroundImage"
														loading="lazy"
													/>
													<!-- Display video if available or both image and video are available -->
														<img
															i18n="@@fundraiserCard_createBackgroundImage"
															*ngIf="
																this.fundraiserData?.image?.video ||
																(this.fundraiserData?.image?.src != null &&
																this.fundraiserData?.image?.video)
															"
															[src]="this.youtubeThumbnail"
															loading="lazy"
														/>
													<!-- Display a default image if none of the above conditions are met -->
														<img
															*ngIf="
																!(
																	this.fundraiserData?.image?.src &&
																	this.fundraiserData?.image?.video
																) && fundraiserData?.image?.src == null
															"
															src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fundraiser_default_bg/public"
															loading="lazy"
														/>
												</div>&nbsp;&nbsp;
												<div
													fxFlex="65"
													fxLayout="column"
													fxLayoutGap="8px"
													
												>
													<p class="mat-title">{{ title }}</p>
													<mat-label>
														<b>{{ currency }}{{ donationReceived }}</b>
														<span
															i18n="@@fundraiserCard_donationTargetedAmount"
															class="light-grey-texts"
														>
															Of
														</span>
														<span class="light-grey-texts">
															{{ currency }}{{ targetAmount }}
														</span>
													</mat-label>

													<div>
														<mat-progress-bar
															class="m-b-xs"
															mode="determinate"
															[value]="donationProgressPercentage"
														></mat-progress-bar>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="m-b-xs">
								<mat-button-toggle-group
									[(ngModel)]="selectedDonationType"
									exclusive
									fxLayout="row"
									fxLayoutAlign="center center"
									fxFlexFill
								>
									<mat-button-toggle
										*ngIf="getFlagValue(ONCE)"
										value="once"
										class="w-100"
										[ngStyle]="
											selectedDonationType === 'once'
												? { backgroundColor: '#e0e0f8' }
												: {}
										"
									>
										<span *ngIf="selectedDonationType === 'once'">✔ </span
										>{{ oneTimeLabel }}
									</mat-button-toggle>

									<mat-button-toggle
										*ngIf="getFlagValue(MONTHLY)"
										value="monthly"
										class="w-100"
										[ngStyle]="
											selectedDonationType === 'monthly'
												? { backgroundColor: '#e0e0f8' }
												: {}
										"
									>
										<span *ngIf="selectedDonationType === 'monthly'">✔ </span
										>{{ monthlyLabel }}
									</mat-button-toggle>

									<mat-button-toggle
										*ngIf="getFlagValue(YEARLY)"
										value="yearly"
										class="w-100"
										[ngStyle]="
											selectedDonationType === 'yearly'
												? { backgroundColor: '#e0e0f8' }
												: {}
										"
									>
										<span *ngIf="selectedDonationType === 'yearly'">✔ </span
										>{{ yearlyLabel }}
									</mat-button-toggle>
								</mat-button-toggle-group>
							</div>

							<div [ngSwitch]="selectedDonationType" fxLayout="column">
								<!-- One Time Content -->
								<div *ngSwitchCase="'once'">
									<div
										*ngIf="!getOpenAmountFlagValue(ONCE)"
										fxLayout="row wrap"
										fxLayoutAlign="center"
										class="m-b-m"
									>
									<div class="p-t-s">
										<button mat-flat-button color="primary">
											{{ currency
											}}{{ getAmountValue(ONCE, 1) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(ONCE, 2) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(ONCE, 3) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(ONCE, 4) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s" *ngIf="oneTime5Available">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(ONCE, 5) | number }}</button
										>&nbsp;&nbsp;&nbsp;
										</div>
									</div>
									<div
										*ngIf="getOpenAmountFlagValue(ONCE)"
										fxLayout="row"
										fxLayoutAlign="start center"
										class="p-t-m"
									>
										<mat-form-field appearance="outline" fxFlex>
											<mat-label i18n="@@enter_amount_label">
												Enter Amount (EURO)
											</mat-label>
											<span matPrefix>&nbsp;&nbsp;&nbsp;{{ currency }}&nbsp;</span>
											<input 
											#customDonationAmount
											required
											matInput 
											type="number" 
											value="0"
											(focus)="clearZero(customDonationAmount)"
											placeholder="00"
											class="right-align"
											appNumbersOnly />
										</mat-form-field>
									</div>
								</div>

								<!-- Monthly Content -->
								<div *ngSwitchCase="'monthly'">
									<div
										*ngIf="!getOpenAmountFlagValue(MONTHLY)"
										fxLayout="row wrap"
										fxLayoutAlign="center"
										class="m-b-m"
									>
									<div class="p-t-s">
										<button mat-flat-button color="primary">
											{{ currency
											}}{{ getAmountValue(MONTHLY, 1) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(MONTHLY, 2) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(MONTHLY, 3) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(MONTHLY, 4) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s" *ngIf="monthly5Available">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(MONTHLY, 5) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									</div>
									<div
										*ngIf="getOpenAmountFlagValue(MONTHLY)"
										fxLayout="row"
										fxLayoutAlign="start center"
										class="p-t-m"
									>
										<mat-form-field appearance="outline" fxFlex>
											<mat-label i18n="@@enter_amount_label">
												Enter Amount (EURO)
											</mat-label>
											<span matPrefix>&nbsp;&nbsp;&nbsp;{{ currency }}&nbsp;</span>
											<input 
											#customDonationAmount
											required
											matInput 
											type="number" 
											value="0"
											(focus)="clearZero(customDonationAmount)"
											placeholder="00"
											class="right-align"
											appNumbersOnly />
										</mat-form-field>
									</div>
								</div>

								<!-- Yearly Content -->
								<div *ngSwitchCase="'yearly'">
									<div
										*ngIf="!getOpenAmountFlagValue(YEARLY)"
										fxLayout="row wrap"
										fxLayoutAlign="center"
										class="m-b-m"
									>
									<div class="p-t-s">
										<button mat-flat-button color="primary">
											{{ currency
											}}{{ getAmountValue(YEARLY, 1) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(YEARLY, 2) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(YEARLY, 3) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(YEARLY, 4) | number }}</button
										>&nbsp;&nbsp;&nbsp;
									</div>
									<div class="p-t-s" *ngIf="yearly5Available">
										<button mat-stroked-button>
											{{ currency
											}}{{ getAmountValue(YEARLY, 5) | number }}</button
										>&nbsp;&nbsp;&nbsp;
										</div>
									</div>
									<div
										*ngIf="getOpenAmountFlagValue(YEARLY)"
										fxLayout="row"
										fxLayoutAlign="start center"
										class="p-t-m"
									>
										<mat-form-field appearance="outline" fxFlex>
											<mat-label i18n="@@enter_amount_label">
												Enter Amount (EURO)
											</mat-label>
											<span matPrefix>&nbsp;&nbsp;&nbsp;{{ currency }}&nbsp;</span>
											<input 
											#customDonationAmount
											required
											matInput 
											type="number" 
											value="0"
											(focus)="clearZero(customDonationAmount)"
											placeholder="00"
											class="right-align"
											appNumbersOnly />
										</mat-form-field>
									</div>
								</div>

								<div fxLayout="column" fxLayoutAlign="center center">
									<div
										fxLayout="column"
										fxLayoutAlign="start start"
										*ngIf="getFlagValue('tipBox')"
										fxFill
									>
										<span
											i18n="@@custom_donationForm_tipBoxEnabled_toggle"
											class="m-b-m"
										>
											Tip</span
										>
										&nbsp;
										<mat-slider
											[min]="0"
											[max]="maxTip"
											[step]="1"
											[discrete]="true"
											[displayWith]="formatLabel"
											[showTickMarks]="true"
											class="slider"
											name="tipSlider"
											ngDefaultControl
										>
											<input matSliderThumb />
										</mat-slider>
									</div>

									<button
										mat-flat-button
										fxFill
										color="accent"
										fxFlex="0 0 40px"
									>
										<div fxLayout="row" fxLayoutAlign="center center">
											<span i18n="@@button_donate">Donate</span>
										</div>
									</button>
								</div>
							</div>
						</mat-card-content>
					</mat-card>
				</mat-card-content>
			</mat-card>
		</div>
	</mat-tab>
</mat-tab-group>
